/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Lms.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CallbackRequest,
  ConfirmEmailVerificationRequest,
  ConfirmEmailVerificationResponse,
  ForgotPasswordRequest,
  ForgotPasswordResponse,
  GetCurrentUserResponse,
  PasswordLoginRequest,
  PasswordLoginResponse,
  ProblemDetails,
  RegisterRequest,
  RegisterResponse,
  ResendEmailVerificationRequest,
  ResendEmailVerificationResponse,
  ResetPasswordRequest,
  ResetPasswordResponse
} from '../../../types/api';

import { apiClient } from '../../client/api-client.ts';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Initiates the WorkOS authentication flow by generating an authorization URL
 * @summary Initiate login flow
 */
export const login = (

 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/auth/login`, method: 'GET', signal
    },
      );
    }




export const getLoginQueryKey = () => {
    return [
    `/api/auth/login`
    ] as const;
    }


export const getLoginQueryOptions = <TData = Awaited<ReturnType<typeof login>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof login>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLoginQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof login>>> = ({ signal }) => login(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof login>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LoginQueryResult = NonNullable<Awaited<ReturnType<typeof login>>>
export type LoginQueryError = unknown


export function useLogin<TData = Awaited<ReturnType<typeof login>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof login>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof login>>,
          TError,
          Awaited<ReturnType<typeof login>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLogin<TData = Awaited<ReturnType<typeof login>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof login>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof login>>,
          TError,
          Awaited<ReturnType<typeof login>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLogin<TData = Awaited<ReturnType<typeof login>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof login>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Initiate login flow
 */

export function useLogin<TData = Awaited<ReturnType<typeof login>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof login>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLoginQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Authenticates via the WorkOS password grant and establishes the LMS session cookie
 * @summary Authenticate with email and password
 */
export const passwordLogin = (
    passwordLoginRequest: PasswordLoginRequest,
 signal?: AbortSignal
) => {


      return apiClient<PasswordLoginResponse>(
      {url: `/api/auth/password-login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: passwordLoginRequest, signal
    },
      );
    }




export const getPasswordLoginMutationKey = () => ['passwordLogin'] as const;

export const getPasswordLoginMutationOptions = <TError = ProblemDetails | PasswordLoginResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof passwordLogin>>, TError,PasswordLoginMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof passwordLogin>>, TError,PasswordLoginMutationVariables, TContext> => {

const mutationKey = getPasswordLoginMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof passwordLogin>>, PasswordLoginMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  passwordLogin(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PasswordLoginMutationResult = NonNullable<Awaited<ReturnType<typeof passwordLogin>>>
    export type PasswordLoginMutationBody = PasswordLoginRequest
    export type PasswordLoginMutationError = ProblemDetails | PasswordLoginResponse
    export type PasswordLoginMutationVariables = {data: PasswordLoginRequest}

    /**
 * @summary Authenticate with email and password
 */
export const usePasswordLogin = <TError = ProblemDetails | PasswordLoginResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof passwordLogin>>, TError,PasswordLoginMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof passwordLogin>>,
        TError,
        PasswordLoginMutationVariables,
        TContext
      > => {
      return useMutation(getPasswordLoginMutationOptions(options), queryClient);
    }
    /**
 * Creates a new user account via WorkOS with email and password
 * @summary Register a new user
 */
export const register = (
    registerRequest: RegisterRequest,
 signal?: AbortSignal
) => {


      return apiClient<RegisterResponse>(
      {url: `/api/auth/register`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: registerRequest, signal
    },
      );
    }




export const getRegisterMutationKey = () => ['register'] as const;

export const getRegisterMutationOptions = <TError = RegisterResponse | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof register>>, TError,RegisterMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof register>>, TError,RegisterMutationVariables, TContext> => {

const mutationKey = getRegisterMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof register>>, RegisterMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  register(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegisterMutationResult = NonNullable<Awaited<ReturnType<typeof register>>>
    export type RegisterMutationBody = RegisterRequest
    export type RegisterMutationError = RegisterResponse | ProblemDetails
    export type RegisterMutationVariables = {data: RegisterRequest}

    /**
 * @summary Register a new user
 */
export const useRegister = <TError = RegisterResponse | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof register>>, TError,RegisterMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof register>>,
        TError,
        RegisterMutationVariables,
        TContext
      > => {
      return useMutation(getRegisterMutationOptions(options), queryClient);
    }
    /**
 * Requests a password reset email; the response is identical whether or not an account exists
 * @summary Request a password reset link
 */
export const forgotPassword = (
    forgotPasswordRequest: ForgotPasswordRequest,
 signal?: AbortSignal
) => {


      return apiClient<ForgotPasswordResponse>(
      {url: `/api/auth/forgot-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: forgotPasswordRequest, signal
    },
      );
    }




export const getForgotPasswordMutationKey = () => ['forgotPassword'] as const;

export const getForgotPasswordMutationOptions = <TError = ProblemDetails | ForgotPasswordResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forgotPassword>>, TError,ForgotPasswordMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof forgotPassword>>, TError,ForgotPasswordMutationVariables, TContext> => {

const mutationKey = getForgotPasswordMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof forgotPassword>>, ForgotPasswordMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  forgotPassword(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ForgotPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof forgotPassword>>>
    export type ForgotPasswordMutationBody = ForgotPasswordRequest
    export type ForgotPasswordMutationError = ProblemDetails | ForgotPasswordResponse
    export type ForgotPasswordMutationVariables = {data: ForgotPasswordRequest}

    /**
 * @summary Request a password reset link
 */
export const useForgotPassword = <TError = ProblemDetails | ForgotPasswordResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forgotPassword>>, TError,ForgotPasswordMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof forgotPassword>>,
        TError,
        ForgotPasswordMutationVariables,
        TContext
      > => {
      return useMutation(getForgotPasswordMutationOptions(options), queryClient);
    }
    /**
 * Completes a password reset using a one-time token and new password; no session is created
 * @summary Complete a password reset
 */
export const resetPassword = (
    resetPasswordRequest: ResetPasswordRequest,
 signal?: AbortSignal
) => {


      return apiClient<ResetPasswordResponse>(
      {url: `/api/auth/reset-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resetPasswordRequest, signal
    },
      );
    }




export const getResetPasswordMutationKey = () => ['resetPassword'] as const;

export const getResetPasswordMutationOptions = <TError = ResetPasswordResponse | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,ResetPasswordMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,ResetPasswordMutationVariables, TContext> => {

const mutationKey = getResetPasswordMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetPassword>>, ResetPasswordMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  resetPassword(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetPassword>>>
    export type ResetPasswordMutationBody = ResetPasswordRequest
    export type ResetPasswordMutationError = ResetPasswordResponse | ProblemDetails
    export type ResetPasswordMutationVariables = {data: ResetPasswordRequest}

    /**
 * @summary Complete a password reset
 */
export const useResetPassword = <TError = ResetPasswordResponse | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,ResetPasswordMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetPassword>>,
        TError,
        ResetPasswordMutationVariables,
        TContext
      > => {
      return useMutation(getResetPasswordMutationOptions(options), queryClient);
    }
    /**
 * Completes a pending password login by confirming the emailed code and establishes the LMS session cookie
 * @summary Confirm email ownership with the emailed 6-digit code
 */
export const confirmEmailVerification = (
    confirmEmailVerificationRequest: ConfirmEmailVerificationRequest,
 signal?: AbortSignal
) => {


      return apiClient<ConfirmEmailVerificationResponse>(
      {url: `/api/auth/email-verification/confirm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmEmailVerificationRequest, signal
    },
      );
    }




export const getConfirmEmailVerificationMutationKey = () => ['confirmEmailVerification'] as const;

export const getConfirmEmailVerificationMutationOptions = <TError = ProblemDetails | ConfirmEmailVerificationResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmEmailVerification>>, TError,ConfirmEmailVerificationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmEmailVerification>>, TError,ConfirmEmailVerificationMutationVariables, TContext> => {

const mutationKey = getConfirmEmailVerificationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmEmailVerification>>, ConfirmEmailVerificationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  confirmEmailVerification(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmEmailVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof confirmEmailVerification>>>
    export type ConfirmEmailVerificationMutationBody = ConfirmEmailVerificationRequest
    export type ConfirmEmailVerificationMutationError = ProblemDetails | ConfirmEmailVerificationResponse
    export type ConfirmEmailVerificationMutationVariables = {data: ConfirmEmailVerificationRequest}

    /**
 * @summary Confirm email ownership with the emailed 6-digit code
 */
export const useConfirmEmailVerification = <TError = ProblemDetails | ConfirmEmailVerificationResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmEmailVerification>>, TError,ConfirmEmailVerificationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmEmailVerification>>,
        TError,
        ConfirmEmailVerificationMutationVariables,
        TContext
      > => {
      return useMutation(getConfirmEmailVerificationMutationOptions(options), queryClient);
    }
    /**
 * Re-sends the branded verification code email for a pending login; no session is created
 * @summary Resend the email verification code
 */
export const resendEmailVerification = (
    resendEmailVerificationRequest: ResendEmailVerificationRequest,
 signal?: AbortSignal
) => {


      return apiClient<ResendEmailVerificationResponse>(
      {url: `/api/auth/email-verification/resend`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resendEmailVerificationRequest, signal
    },
      );
    }




export const getResendEmailVerificationMutationKey = () => ['resendEmailVerification'] as const;

export const getResendEmailVerificationMutationOptions = <TError = ProblemDetails | ResendEmailVerificationResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendEmailVerification>>, TError,ResendEmailVerificationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof resendEmailVerification>>, TError,ResendEmailVerificationMutationVariables, TContext> => {

const mutationKey = getResendEmailVerificationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendEmailVerification>>, ResendEmailVerificationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  resendEmailVerification(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendEmailVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof resendEmailVerification>>>
    export type ResendEmailVerificationMutationBody = ResendEmailVerificationRequest
    export type ResendEmailVerificationMutationError = ProblemDetails | ResendEmailVerificationResponse
    export type ResendEmailVerificationMutationVariables = {data: ResendEmailVerificationRequest}

    /**
 * @summary Resend the email verification code
 */
export const useResendEmailVerification = <TError = ProblemDetails | ResendEmailVerificationResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendEmailVerification>>, TError,ResendEmailVerificationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resendEmailVerification>>,
        TError,
        ResendEmailVerificationMutationVariables,
        TContext
      > => {
      return useMutation(getResendEmailVerificationMutationOptions(options), queryClient);
    }
    /**
 * Processes the WorkOS authentication callback and establishes user session
 * @summary Handle authentication callback
 */
export const authCallback = (
    callbackRequest: CallbackRequest,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/auth/callback`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: callbackRequest, signal
    },
      );
    }




export const getAuthCallbackMutationKey = () => ['authCallback'] as const;

export const getAuthCallbackMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authCallback>>, TError,AuthCallbackMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authCallback>>, TError,AuthCallbackMutationVariables, TContext> => {

const mutationKey = getAuthCallbackMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authCallback>>, AuthCallbackMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authCallback(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthCallbackMutationResult = NonNullable<Awaited<ReturnType<typeof authCallback>>>
    export type AuthCallbackMutationBody = CallbackRequest
    export type AuthCallbackMutationError = unknown
    export type AuthCallbackMutationVariables = {data: CallbackRequest}

    /**
 * @summary Handle authentication callback
 */
export const useAuthCallback = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authCallback>>, TError,AuthCallbackMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authCallback>>,
        TError,
        AuthCallbackMutationVariables,
        TContext
      > => {
      return useMutation(getAuthCallbackMutationOptions(options), queryClient);
    }
    /**
 * Logs out the current user and clears their session
 * @summary Logout user
 */
export const logout = (

 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/auth/logout`, method: 'POST', signal
    },
      );
    }




export const getLogoutMutationKey = () => ['logout'] as const;

export const getLogoutMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext> => {

const mutationKey = getLogoutMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logout>>, void> = () => {


          return  logout()
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogoutMutationResult = NonNullable<Awaited<ReturnType<typeof logout>>>

    export type LogoutMutationError = unknown


    /**
 * @summary Logout user
 */
export const useLogout = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof logout>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getLogoutMutationOptions(options), queryClient);
    }
    /**
 * Returns information about the currently authenticated user
 * @summary Get current user
 */
export const getCurrentUser = (

 signal?: AbortSignal
) => {


      return apiClient<GetCurrentUserResponse>(
      {url: `/api/auth/me`, method: 'GET', signal
    },
      );
    }




export const getGetCurrentUserQueryKey = () => {
    return [
    `/api/auth/me`
    ] as const;
    }


export const getGetCurrentUserQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentUserQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUser>>> = ({ signal }) => getCurrentUser(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCurrentUserQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentUser>>>
export type GetCurrentUserQueryError = unknown


export function useGetCurrentUser<TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUser>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentUser<TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUser>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentUser<TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current user
 */

export function useGetCurrentUser<TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurrentUserQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






